import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdBuilding_managers = z.any()
export type TagsGetMunicipalities_municipalityIdBuilding_managers = z.infer<typeof tagsGetMunicipalities_municipalityIdBuilding_managers>

export const paramsGetMunicipalities_municipalityIdBuilding_managers = z.object({ "municipalityId": z.string() })
export type ParamsGetMunicipalities_municipalityIdBuilding_managers = z.infer<typeof paramsGetMunicipalities_municipalityIdBuilding_managers>

export const querystringGetMunicipalities_municipalityIdBuilding_managers = z.object({ "buildingId": z.string().optional() })
export type QuerystringGetMunicipalities_municipalityIdBuilding_managers = z.infer<typeof querystringGetMunicipalities_municipalityIdBuilding_managers>

export const responseGetMunicipalities_municipalityIdBuilding_managers = z.object({ "payload": z.array(z.object({ "id": z.string().uuid(), "name": z.string(), "email": z.string(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdBuilding_managers = z.infer<typeof responseGetMunicipalities_municipalityIdBuilding_managers>

interface IGetMunicipalities_municipalityIdBuilding_managers extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdBuilding_managers,
  params: ParamsGetMunicipalities_municipalityIdBuilding_managers,
  querystring: QuerystringGetMunicipalities_municipalityIdBuilding_managers,
  response: ResponseGetMunicipalities_municipalityIdBuilding_managers
}
export const URL = '/municipalities/:municipalityId/building-managers'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdBuilding_managers,
    params: paramsGetMunicipalities_municipalityIdBuilding_managers,
    querystring: querystringGetMunicipalities_municipalityIdBuilding_managers,
    response: responseGetMunicipalities_municipalityIdBuilding_managers
  }
}
export interface Municipalities_municipalityIdBuilding_managers extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdBuilding_managers
}